import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSalesReportTableData, postExportReport } from "src/api/sp";
import { resetStore } from "src/store/actions";
import { getSalesReportData } from "../../api/bi/index";

type SalesReportTableProps = {
  storeId: string;
  date: string;
};

export const salesReportData = createAsyncThunk(
  "/report/salesinquier",
  (docId: any) => getSalesReportData(docId)
);

export const salesReportTableData = createAsyncThunk(
  "/report/salesInquierTable",
  (docId: SalesReportTableProps) => getSalesReportTableData(docId)
);

export const postingExportSalesReportData = createAsyncThunk(
  "report/postSalesReportData",
  (payload: any) => postExportReport(payload)
);

export const initialState: any = {
  data: {
    totalSales: "",
    departments: [],
    salesTax: ""
  },
  status: "initial",
  departmentsStatus: "initial",
  error: null,
  docId: ""
};

const salesInquirySlice = createSlice({
  name: "salesInquiry",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(salesReportData.pending, (state) => {
        state.status = "pending";
      })
      .addCase(salesReportData.fulfilled, (state, { payload }) => {
        state.status = "idle";
        state.docId = payload.data.docId;
        delete payload?.data?.departments;
        delete payload?.data?.totalSales;
        state.data = {
          ...state.data,
          ...(payload?.data || {}),
          customerCount: payload?.data?.customerCount || ""
        };
      })
      .addCase(salesReportData.rejected, (state, _action) => {
        state.status = "error";
        state.data = {};
      })
      .addCase(salesReportTableData.pending, (state) => {
        state.departmentsStatus = "pending";
      })
      .addCase(salesReportTableData.fulfilled, (state, { payload }) => {
        state.departmentsStatus = "idle";
        const { totalSales, departments, salesTax } = payload.data;
        state.data.departments = departments;
        state.data.totalSales = totalSales;
        state.data.salesTax = salesTax;
      })
      .addCase(salesReportTableData.rejected, (state, _action) => {
        state.departmentsStatus = "error";
        state.data.departments = [];
      });
  }
});

export default salesInquirySlice.reducer;
